import { View } from 'components/View'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import React from 'react'
import { defineMessages } from 'react-intl'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import useIntl from 'modules/component/utils/hooks/useIntl.js'
import ButtonPrimary from 'components/ButtonPrimary/index.js'
import { ROUTE_PATH } from 'modules/routes/constants/index.cjs'
import logEventAnalyticsUtil from 'modules/analytics/utils/log-event/index.js'
import { GetAppButton } from 'components/DownloadButton/index.js'
import TextBodySmaller from 'components/TextBodySmaller.js'
import { isLoggedInTrainingUserSelect } from 'modules/training/modules/training-users/selectors/is-logged-in'
import { hasSeenOnboardingModalRecentlyProfileUtil } from 'modules/profile/utils/hasSeenOnboardingModalRecently/index.js'

const messages = defineMessages({
  trusted: {
    id: 'AppCTA.trusted',
    defaultMessage: '⭐ Trusted by 80,000+ fitness lovers worldwide.'
  },
  getStarted: {
    id: 'AppCTA.getStarted',
    defaultMessage: 'Get started'
  },
  preferToStartInTheApp: {
    id: 'AppCTA.preferToStartInTheApp',
    defaultMessage: 'Prefer to start in the app?'
  }
})

const ANALYTIC_EVENT = {
  LANDING_NAVIGATE_TO_PREMIUM_WITH_ONBOARDING: 'LANDING_NAVIGATE_TO_PREMIUM_WITH_ONBOARDING',
  LANDING_OPEN_LOGIN: 'LANDING_OPEN_LOGIN'
}

/**
 * @param isCentered
 * @returns {JSX.Element}
 * @constructor
 */
export const AppCTA = ({
  isCentered
}) => {
  const intl = useIntl()
  const isSmallScreen = useSelector(isSmallScreenViewportSelect)
  const isLoggedIn = useSelector(isLoggedInTrainingUserSelect)

  const hasSeenOnboardingRecently = hasSeenOnboardingModalRecentlyProfileUtil()

  const handleClick = () => {
    if (isLoggedIn) {
      logEventAnalyticsUtil(ANALYTIC_EVENT.LANDING_NAVIGATE_TO_PREMIUM_WITH_ONBOARDING)
    } else if (hasSeenOnboardingRecently) {
      logEventAnalyticsUtil(ANALYTIC_EVENT.LANDING_OPEN_LOGIN)
    } else {
      logEventAnalyticsUtil(ANALYTIC_EVENT.LANDING_NAVIGATE_TO_PREMIUM_WITH_ONBOARDING)
    }
  }

  let ctaUrl = ROUTE_PATH.ACCOUNT
  if (!isLoggedIn) {
    const actionParam = hasSeenOnboardingRecently ? 'openLogin=true' : 'showOnboarding=true'
    ctaUrl = `${ROUTE_PATH.ACCOUNT}?${actionParam}`
  }

  return (
    <View mt={2}>
      <TextBodySmaller
        c='paragraph'
      >
        {formatMessageIntlUtil(intl, messages.trusted)}
      </TextBodySmaller>

      <View mt>
        <ButtonPrimary
          url={ctaUrl}
          onClick={handleClick}
          style={{
            margin: isSmallScreen || isCentered ? '0 auto' : 'unset'
          }}
        >
          {formatMessageIntlUtil(intl, messages.getStarted)}
        </ButtonPrimary>
      </View>

      {isLoggedIn && (
        <View mt={4}>
          <TextBodySmaller>
            {formatMessageIntlUtil(intl, messages.preferToStartInTheApp)}
          </TextBodySmaller>
          <GetAppButton
            appStoreHeight='2.4em'
            playStoreHeight='2.56em'
            style={{
              justifyContent: isCentered || isSmallScreen ? 'center' : 'flex-start'
            }}
          />
        </View>
      )}
    </View>
  )
}
